/**
 * ResponsavelConfigSms
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {ResponsavelConfigSmsCollection} from '@/model/collection/ResponsavelConfigSmsCollection'

/* TODO: review generated class */
export class ResponsavelConfigSms extends Resource {
  idConfigSmsPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  idStatusFk: number | null = null
  mensagem: string | null = null
  ativo: boolean | null = null

  get $id() {
    return this.idConfigSmsPk
  }
  set $id(val) {
    this.idConfigSmsPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of ResponsavelConfigSms
   */
  async getResponsavelConfigSms(id: number) {
    return await Request.get(`/admin/responsavel-config-sms/${id}`)
      .name('getResponsavelConfigSms')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of ResponsavelConfigSms
   */
  async removeResponsavelConfigSms() {
    return await Request.delete(`/admin/responsavel-config-sms/${this.$id}`)
      .name('removeResponsavelConfigSms')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelConfigSms
   */
  static async listResponsavelConfigSms(params: any) {
    return await Request.get(`/admin/responsavel-config-sms`, {params})
      .name('listResponsavelConfigSms')
      .as(ResponsavelConfigSmsCollection)
      .getData()
  }

  /**
   * Persists a new instance of ResponsavelConfigSms. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistResponsavelConfigSms() {
    return await Request.post(`/admin/responsavel-config-sms`, this)
      .name('persistResponsavelConfigSms')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelConfigSms to use it in a CSV file
   */
  static async listCsvResponsavelConfigSms(params: any) {
    return await Request.get(`/admin/responsavel-config-sms/csv`, {params})
      .name('listCsvResponsavelConfigSms')
      .as(ResponsavelConfigSmsCollection)
      .getData()
  }
}
